import type { Product } from "../types";

export const PRODUCTS: Product[] = [
    {
        id: "1",
        name: "Midnight Jasmine",
        description:
            "A seductive blend of night-blooming jasmine, dark amber, and smooth sandalwood.",
        price: 48,
        image: "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?auto=format&fit=crop&q=80&w=800",
        scent: "Floral & Woody",
        notes: ["Jasmine", "Amber", "Sandalwood"],
        burnTime: "60 Hours",
    },
    {
        id: "2",
        name: "Smoked Oud",
        description:
            "Deep, resinous oud wood paired with charred cedar and a hint of black pepper.",
        price: 52,
        image: "https://images.unsplash.com/photo-1603006905003-be475563bc59?auto=format&fit=crop&q=80&w=800",
        scent: "Smoky & Intense",
        notes: ["Oud", "Cedar", "Black Pepper"],
        burnTime: "55 Hours",
    },
    {
        id: "3",
        name: "Bergamot & Sea Salt",
        description:
            "Crisp Italian bergamot balanced with sun-drenched sea salt and white musk.",
        price: 45,
        image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800",
        scent: "Fresh & Citrus",
        notes: ["Bergamot", "Sea Salt", "White Musk"],
        burnTime: "60 Hours",
    },
    {
        id: "4",
        name: "Velvet Rose",
        description:
            "Damask rose petals layered with rich patchouli and a touch of vanilla bean.",
        price: 48,
        image: "https://images.unsplash.com/photo-1532012197267-da84d127e765?auto=format&fit=crop&q=80&w=800",
        scent: "Floral & Sweet",
        notes: ["Rose", "Patchouli", "Vanilla"],
        burnTime: "60 Hours",
    },
    {
        id: "5",
        name: "Sandalwood Forest",
        description:
            "Earthly sandalwood combined with pine needles and damp moss after rain.",
        price: 50,
        image: "https://images.unsplash.com/photo-1605651202774-7d573fd3f12d?auto=format&fit=crop&q=80&w=800",
        scent: "Earthly & Woody",
        notes: ["Sandalwood", "Pine", "Moss"],
        burnTime: "65 Hours",
    },
    {
        id: "6",
        name: "Spiced Fig",
        description:
            "Ripe Mediterranean figs infused with cinnamon bark and star anise.",
        price: 46,
        image: "https://images.unsplash.com/photo-1536657464919-892534f60d6e?auto=format&fit=crop&q=80&w=800",
        scent: "Fruity & Warm",
        notes: ["Fig", "Cinnamon", "Star Anise"],
        burnTime: "55 Hours",
    },
];
